module.exports = __webpack_public_path__ + "static/media/SNX-logo.e549a565.png";